import { computed as t, openBlock as s, createElementBlock as d, normalizeStyle as o, createElementVNode as c, defineCustomElement as l } from "vue";
const i = {
  __name: "Dashboard",
  props: {
    height: {
      type: String,
      default: "70px"
    },
    backgroundColor: {
      type: String,
      default: "rgba(0, 0, 0, 0.3)"
    }
  },
  setup(n) {
    const e = n, r = t(() => ({
      height: e.height,
      backgroundColor: e.backgroundColor,
      position: "fixed",
      width: "100%",
      top: 0,
      left: 0,
      zIndex: "10001"
    })), a = t(() => ({
      margin: "0"
    }));
    return (p, u) => (s(), d("div", {
      id: "vnt-dashboard-topbar",
      style: o(r.value)
    }, [
      c("h1", {
        style: o(a.value)
      }, "Dashboard Components", 4)
    ], 4));
  }
}, m = l(i);
customElements.define("vnt-dashboard", m);
